import { orchestrator } from 'satcheljs';
import { disconnectOWAConnectedAccountFailed } from 'owa-accounts-service';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';
import setAccountsEditorState from '../mutators/setAccountsEditorState';

orchestrator(disconnectOWAConnectedAccountFailed, ({ isReconnectFlow }) => {
    // Set the editor state to removeFailed
    setAccountsEditorState(
        isReconnectFlow ? AccountsEditorState.ReconnectFailed : AccountsEditorState.RemoveFailed
    );
});
